/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Grid,
  Paper,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import EmailIcon from '@mui/icons-material/Email';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import dayjs from 'dayjs';
import api from '../../utils/functions/api';
import TableManagementSuperAdmin from '../../components/TableManagementSuperAdmin';
import { getStorage } from '../../utils/functions/localstorage';
import Loading from '../../components/Loading';

function ManagementSuperAdmin() {
  const [isManagementSuperAdmin, setIsManagementSuperAdmin] = useState([]);
  const [startDateFilter, setStartDateFilter] = useState(
    dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
  );
  const [endDateFilter, setEndDateFilter] = useState(
    dayjs().format('YYYY-MM-DD HH:mm:ss'),
  );
  const [searchText, setSearchText] = useState('');

  const [pagination, setPagination] = useState({
    currPage: 1,
    size: 10,
    lastPage: 1,
    total: 0,
  });
  const [isLoading, setIsLoading] = useState(false);

  const [selectedMerchants, setSelectedMerchants] = useState('');
  const [merchOpt, setMerchOpt] = useState([]);

  const [openAddManagementDialog, setOpenAddManagementDialog] = useState(false);
  const [managementEmail, setManagementEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const getAdminList = async () => {
    try {
      setIsLoading(true);
      const token = getStorage('token');
      const { data } = await api.get(
        `${process.env.REACT_APP_APIHOST}/admin_list`,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      setIsManagementSuperAdmin(data);
      setPagination((prev) => ({
        ...prev,
        total: data.length,
        lastPage: Math.ceil(data.length / pagination.size),
      }));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.message);
    }
  };

  useEffect(() => {
    getAdminList();
  }, []);

  const handleSearchTextChange = (event) => {
    setSearchText(event.target.value);
  };

  const filteredManagementList = isManagementSuperAdmin.filter(
    (management) =>
      management.username?.toLowerCase().includes(searchText.toLowerCase()) ||
      management.email?.toLowerCase().includes(searchText.toLowerCase()),
  );

  const handleMerchantChange = (event, newValueMerchant) => {
    if (newValueMerchant) {
      const newMerchantIds = newValueMerchant.map((option) => option.MERCH_ID);
      setSelectedMerchants(newMerchantIds);
    } else {
      setSelectedMerchants([]);
    }
  };

  const handlePaginationChange = (event, value) => {
    if (event === 'handleChangePage') {
      setPagination((prev) => ({ ...prev, currPage: value }));
    } else {
      setPagination((prev) => ({ ...prev, currPage: 1, size: value }));
    }
  };

  const FinalConfirmationPopup = ({ open, onClose }) => (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: '400px',
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '24px',
            marginTop: '20px',
          }}
        >
          <CheckCircleOutlineIcon
            sx={{ fontSize: 90, color: 'green', marginBottom: '10px' }}
          />
          บันทึกสำเร็จ !
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            width: '25%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid',
            borderRadius: '9px',
            color: '#45A6F5',
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: '#E3F3FF',
            },
            margin: 'auto',
          }}
        >
          <Button onClick={onClose}>Close</Button>
        </Box>
      </DialogActions>
    </Dialog>
  );

  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleCancel = () => {
    setManagementEmail(''); // Clear field data
    setOpenAddManagementDialog(false); // Close dialog
  };

  const handleAdd = () => {
    // checkField();
    // if (!emailError) {
    //   saveAdmin();
    // }
    if (!managementEmail) {
      setEmailError('กรุณากรอกอีเมลล์');
    } else {
      saveAdmin();
    }
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    window.location.reload();
  };

  const checkField = () => {
    if (!managementEmail) {
      setEmailError('กรุณากรอกอีเมลล์');
    } else {
      setEmailError('');
    }
  };

  const saveAdmin = async () => {
    setIsLoading(true);
    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_APIHOST}/add_admin`,
        {
          email: managementEmail,
          createBy: getStorage('username'),
        },
        {
          headers: { Authorization: getStorage('token') },
        },
      );
      if (data === 'Success') {
        setShowConfirmation(true);
      } else if (data === 'Duplicate Email') {
        setEmailError('อีเมลนี้ถูกใช้งานแล้ว กรุณาลองอีกครั้ง');
      }
    } catch (error) {
      console.log(error.message);
      setEmailError('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
    } finally {
      setIsLoading(false);
    }
  };

  const renderFilterFormManagementSuperAdmin = () => (
    <form>
      <Grid
        container
        alignItems="center"
        spacing={2}
        style={{ marginTop: '20px' }}
        justifyContent="space-between"
      >
        <Grid item xs={7} sm={8}>
          <TextField
            className="text"
            label="ค้นหาข้อความ :"
            variant="outlined"
            size="small"
            value={searchText}
            onChange={handleSearchTextChange}
            style={{ marginRight: '20px' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{ marginLeft: '20px' }}
          />
        </Grid>
        <Grid item xs={5} sm={4} container justifyContent="flex-end">
          <Button
            onClick={() => {
              setOpenAddManagementDialog(true);
              setEmailError('');
              setManagementEmail('');
            }}
            variant="contained"
            color="primary"
            size="medium"
            startIcon={<PersonAddIcon />}
            sx={{ marginRight: '20px' }}
          >
            เพิ่มบัญชี
          </Button>
        </Grid>
      </Grid>

      <FinalConfirmationPopup
        open={showConfirmation}
        onClose={handleCloseConfirmation}
      />
    </form>
  );

  return (
    <Grid container>
      <Loading isLoading={isLoading} />
      <Grid item xs={12} md={12}>
        <div className="font-bold text-xl" style={{ marginLeft: '20px' }}>
          SuperAdmin
        </div>
      </Grid>
      <Grid item xs={12} md={12}>
        {renderFilterFormManagementSuperAdmin()}
      </Grid>
      <Grid item xs={12} md={12}>
        <Paper
          sx={{
            overflow: 'hidden',
            marginTop: '20px',
            marginLeft: { xs: '10px', sm: '15px', md: '20px' },
            marginRight: { xs: '10px', sm: '15px', md: '20px' },
          }}
        >
          <TableManagementSuperAdmin
            isManagementSuperAdmin={filteredManagementList}
            pagination={pagination}
            handlePaginationChange={handlePaginationChange}
          />
        </Paper>
      </Grid>

      <Dialog
        open={openAddManagementDialog}
        onClose={() => setOpenAddManagementDialog(false)}
        PaperProps={{
          sx: {
            borderRadius: '15px',
            width: '100%',
            maxWidth: '500px',
          },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontWeight: 'bold',
              fontSize: '20px',
              marginTop: '20px',
            }}
          >
            เพิ่มบัญชี
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '10px',
              marginLeft: '10px',
              marginTop: '6px',
            }}
          >
            <EmailIcon sx={{ marginRight: '30px' }} />
            <TextField
              label="อีเมลล์"
              variant="outlined"
              size="small"
              fullWidth
              value={managementEmail}
              onChange={(e) => setManagementEmail(e.target.value)}
              error={!!emailError}
              helperText={emailError}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ marginBottom: '20px', marginRight: '20px' }}>
          <Button
            onClick={handleCancel}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={handleAdd}
            sx={{
              width: '100px',
              border: '1px solid ',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(81, 210, 69, 0.1)',
              },
            }}
          >
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

export default ManagementSuperAdmin;
